import React from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import './filter.css';

const OrderVenues = ({ onOrderChange, selectedOrder }) => {
  const { t } = useTranslation();

  const onHandleClick = (order) => {
    if (order.id === selectedOrder?.id) {
      order = null;
    }

    if (onOrderChange) onOrderChange(order);
  };

  const orders = [
    { id: 'FEATURED', name: t('orderVenues.FEATURED') }, 
    { id: 'NEWER', name: t('orderVenues.NEWER') },
    { id: 'MOST_SALES', name: t('orderVenues.MOST_SALES') },
    { id: 'MOST_COMMISSION', name: t('orderVenues.MOST_COMMISSION') },
  ];

  return (
    <Swiper spaceBetween={5} slidesPerView={'auto'}>
      {orders.length > 0 &&
        orders.map((o, index) => (
          <SwiperSlide key={index}>
            <button
              className={`button-filter small ${selectedOrder?.id === o.id ? 'active' : ''}`}
              onClick={() => onHandleClick(o)}
            >
              {o.name}
            </button>
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export default OrderVenues;
